import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../App.css";
import photo from "../assets/pic3.jpg";

const API_URL = "/api";
// const API_URL = "http://localhost:5000/api";

const showAlert = (message) => {
  alert(message);
};

const HomePage = () => {
  const navigate = useNavigate();
  const [selectedTable, setSelectedTable] = useState(1);

  const [schedule, setSchedule] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [isAgreed, setIsAgreed] = useState(false);
  const [scheduleError, setScheduleError] = useState(false);

  const [stickyButtonVisible, setStickyButtonVisible] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [userName, setUserName] = useState(
    localStorage.getItem("thefeels_name") || "",
  );
  const [userPhone, setUserPhone] = useState(
    localStorage.getItem("thefeels_phone") || "+7",
  );
  const [showWarning, setShowWarning] = useState(false);

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [userBookings, setUserBookings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [isLoadingBooking, setIsLoadingBooking] = useState(false);

  // const [isLoadingCancel, setIsLoadingCancel] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});
  const [pricing, setPricing] = useState({
    weekday_day_price: 800,
    weekday_evening_price: 1500,
    weekend_price: 1500,
  });

  // const PRICE_PER_HOUR = 1500;
  // console.log(userBookings);

  const fetchSchedule = async (tableId) => {
    try {
      const response = await fetch(`${API_URL}/schedule/${tableId}`);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setSchedule(data);
      setScheduleError(false);
      return data;
    } catch (error) {
      console.error("Error fetching schedule:", error);
      setScheduleError(true);
      return [];
    }
  };

  const fetchPricing = async () => {
    try {
      const response = await fetch(`${API_URL}/pricing`);

      const data = await response.json();

      setPricing(data);
    } catch (error) {
      console.error("Error fetching pricing:", error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchSchedule(selectedTable);
    }, 10000); // каждые 10 секунд

    return () => clearInterval(intervalId);
  }, [selectedTable]);

  // const updateSchedule = (newSchedule) => {
  //   setSchedule(newSchedule);
  // };

  useEffect(() => {
    fetchSchedule(1);
    fetchPricing();
  }, []);

  const handleTableSelect = async (tableId) => {
    await fetchSchedule(tableId);
    setSelectedTable(tableId);
    setSelectedSlots([]);
    setStickyButtonVisible(false);
  };

  const handleSlotSelect = (date, slot) => {
    const selectedTimes = selectedSlots.map((s) => s.time);
    const isSelected = selectedTimes.includes(slot.time);

    if (isSelected) {
      const updatedSlots = selectedSlots.filter((s) => s.time !== slot.time);
      setSelectedSlots(updatedSlots);
      if (updatedSlots.length === 0) {
        setStickyButtonVisible(false);
        setShowWarning(false);
      }
      return;
    }

    if (selectedSlots.length > 0 && selectedSlots[0].date !== date) {
      showAlert("Вы можете выбирать слоты только в рамках одной даты.");
      setSelectedSlots([{ date, time: slot.time }]);
      setStickyButtonVisible(true);
      return;
    }

    setSelectedSlots((prev) => [...prev, { date, time: slot.time }]);
    setStickyButtonVisible(true);
  };

  const handleDialogConfirm = async () => {
    if (!validatePhoneConfirm(userPhone)) {
      showAlert(
        "Пожалуйста, введите корректный номер телефона. Форматы: 8XXXXXXXXXX, +7XXXXXXXXXX.",
      );
      return;
    }
    setIsLoadingBooking(true);
    try {
      console.log("Starting booking process...");
      console.log("Selected slots:", selectedSlots);

      const sortedSlots = [...selectedSlots].sort((a, b) => {
        const timeA = a.time.split("-")[0];
        const timeB = b.time.split("-")[0];
        return timeToMinutes(timeA) - timeToMinutes(timeB);
      });
      console.log("Sorted slots:", sortedSlots);

      // Парсим базовую дату из первого слота (формат: "16.06.26 (Воскресенье)")
      // const baseDateStr = sortedSlots[0].date.split(" ")[0]; // "16.06.26"
      // const [baseDay, baseMonth, baseYear] = baseDateStr.split(".");
      // const baseDate = new Date(
      //   2000 + parseInt(baseYear),
      //   parseInt(baseMonth) - 1,
      //   parseInt(baseDay),
      // );

      // Группируем слоты по дате из UI (без сдвига для ночных слотов)
      const slotsByDate = {};

      sortedSlots.forEach((slot) => {
        const dateKey = slot.date.split(" ")[0]; // "17.06.26" — без изменений

        if (!slotsByDate[dateKey]) {
          slotsByDate[dateKey] = [];
        }
        slotsByDate[dateKey].push(slot);
      });

      console.log("Slots grouped by date:", slotsByDate);

      // Формируем запросы для каждой группы
      const bookingRequests = Object.entries(slotsByDate).map(
        ([date, slots]) => {
          const sortedGroupSlots = [...slots].sort((a, b) => {
            return (
              timeToMinutes(a.time.split("-")[0]) -
              timeToMinutes(b.time.split("-")[0])
            );
          });

          return {
            tableId: selectedTable,
            date: date,
            slots: sortedGroupSlots.map((slot) => ({
              startTime: slot.time.split("-")[0].trim(),
              endTime: slot.time.split("-")[1].trim(),
            })),
            clientName: userName,
            clientPhone: userPhone.replace(/\D/g, ""),
            tg_id: null,
          };
        },
      );

      console.log("Sending booking requests:", bookingRequests);

      // Отправляем все запросы параллельно
      const responses = await Promise.all(
        bookingRequests.map((data) =>
          fetch(`${API_URL}/booking`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          }),
        ),
      );

      // Проверяем ответы
      for (const response of responses) {
        if (response.status === 409) {
          console.log("Slot already booked, updating schedule...");
          showAlert(
            "Извините, этот слот уже забронирован. Обновляем расписание...",
          );
          await fetchSchedule(selectedTable);
          setSelectedSlots([]);
          setStickyButtonVisible(false);
          setShowDialog(false);
          return;
        }
        if (!response.ok) {
          throw new Error("Booking failed");
        }
      }

      console.log("Backend booking successful");

      localStorage.setItem("thefeels_name", userName);

      // Нормализуем телефон: убираем всё кроме цифр, заменяем 8 на 7
      let normalizedPhone = userPhone.replace(/\D/g, "");
      if (normalizedPhone.startsWith("8") && normalizedPhone.length === 11) {
        normalizedPhone = "7" + normalizedPhone.substring(1);
      }
      const phoneWithPlus = "+" + normalizedPhone;
      localStorage.setItem("thefeels_phone", phoneWithPlus);

      console.log("Updating UI...");
      setShowDialog(false);
      setSelectedSlots([]);
      setStickyButtonVisible(false);
      setUserName("");
      setUserPhone("+7");
      setIsAgreed(false);
      navigate("/booking-success");
    } catch (error) {
      console.error("Booking error details:", {
        error: error.message,
        stack: error.stack,
        type: error.name,
      });
      showAlert("Ошибка при бронировании");
    } finally {
      console.log("Booking process completed");
      setIsLoadingBooking(false);
    }
  };

  const validatePhoneConfirm = (phone) => {
    const phoneRegex = /^(8\d{10}|\+7\d{10})$/;
    return phoneRegex.test(phone);
  };

  const handleConfirm = () => {
    // 1. Безопасно находим расписание выбранного дня
    const currentDaySchedule = schedule.find(
      (d) => d.date === selectedSlots[0]?.date,
    );

    // 2. Если расписание ещё не загрузилось или дата не найдена, прерываем выполнение
    if (!currentDaySchedule) {
      showAlert("Расписание загружается, подождите секунду...");
      return;
    }

    const selectedIndices = selectedSlots.map((s) =>
      currentDaySchedule.slots.findIndex((t) => t.time === s.time),
    );

    const sortedIndices = [...selectedIndices].sort((a, b) => a - b);

    const isNonAdjacent = sortedIndices.some(
      (slotIndex, i) => i > 0 && slotIndex !== sortedIndices[i - 1] + 1,
    );

    if (isNonAdjacent) {
      setShowWarning(true);
      setStickyButtonVisible(false);
      return;
    }
    // fetchUserData();
    setShowDialog(true);
    setStickyButtonVisible(false);
  };

  const handleResetSlots = () => {
    setSelectedSlots([]);
    setShowWarning(false);
    setStickyButtonVisible(false);
  };

  const handleDialogCancel = () => {
    setIsAgreed(false);
    setShowDialog(false);
    setSelectedSlots([]);
    setStickyButtonVisible(false);
  };

  const formatTimeRange = (slots) => {
    if (slots.length < 2) {
      return slots[0].time;
    }

    const sortedSlots = [...slots].sort((a, b) => {
      const timeA = a.time.split("-")[0];
      const timeB = b.time.split("-")[0];
      return timeToMinutes(timeA) - timeToMinutes(timeB);
    });

    const firstSlotStart = sortedSlots[0].time.split("-")[0];
    const lastSlotEnd = sortedSlots[sortedSlots.length - 1].time.split("-")[1];

    return `${firstSlotStart}-${lastSlotEnd}`;
  };

  const timeToMinutes = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    // Для слотов после полуночи (00:00-03:00) добавляем 24 часа,
    // чтобы они корректно сортировались после вечерних слотов
    const adjustedHours = hours >= 0 && hours < 3 ? hours + 24 : hours;
    return adjustedHours * 60 + minutes;
  };

  const calculateTotalPrice = (slots) => {
    if (!slots || slots.length === 0) return 0;

    return slots.reduce((total, slot) => {
      const price = getPriceForSlot(slot);
      return total + price;
    }, 0);
  };

  const getPriceForSlot = (slot) => {
    // Для всех столов цены зависят от дня и времени
    const startTime = slot.time.split("-")[0].trim();
    const slotDate = parseDateString(slot.date.split(" ")[0]);
    slotDate.setHours(
      parseInt(startTime.split(":")[0], 10),
      parseInt(startTime.split(":")[1], 10),
      0,
      0,
    );
    const dayOfWeek = slotDate.getDay(); // 0 = воскресенье, 1 = понедельник, ..., 6 = суббота
    const hour = slotDate.getHours();

    if (dayOfWeek === 0 || dayOfWeek === 6) {
      return pricing.weekend_price;
    }

    if (dayOfWeek >= 1 && dayOfWeek <= 5) {
      if (hour >= 13 && hour < 17) {
        return pricing.weekday_day_price;
      }
      return pricing.weekday_evening_price;
    }

    return pricing.weekend_price;
  };

  useEffect(() => {
    const handleScroll = () => {
      const photoContainer = document.querySelector(".photo-container");
      const photo = document.querySelector(".photo");

      if (!photoContainer || !photo) return;

      const containerRect = photoContainer.getBoundingClientRect();
      const scrollProgress = window.scrollY;

      if (containerRect.bottom > 0 && containerRect.top < window.innerHeight) {
        const translateY = Math.min(
          scrollProgress * 0.3,
          containerRect.height * 0.3,
        );

        photo.style.transform = `translateY(${translateY}px)`;

        const scrollPercentage = scrollProgress / containerRect.height;
        const opacity = Math.max(1 - scrollPercentage * 0.5, 0.6);
        const brightness = Math.max(0.85 - scrollPercentage * 0.2, 0.65);
        const saturation = Math.max(1 - scrollPercentage * 0.3, 0.7);

        photo.style.opacity = opacity;
        photo.style.filter = `brightness(${brightness}) contrast(1.1) saturate(${saturation})`;
        if (scrollProgress > 50) {
          photo.classList.add("scrolled");
        } else {
          photo.classList.remove("scrolled");
        }
      }
    };

    let ticking = false;
    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const validateName = (name) => {
    const nameRegex = /^[a-zA-Zа-яА-ЯёЁ\s]*$/;
    return nameRegex.test(name);
  };

  const handleNameChange = (e) => {
    const newName = e.target.value;
    if (validateName(newName) && newName.length <= 30) {
      setUserName(newName.trim());
    }
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^\+?\d{1,15}$/;
    return phoneRegex.test(phone);
  };

  const handlePhoneChange = (e) => {
    const newPhone = e.target.value;
    if (validatePhone(newPhone)) {
      setUserPhone(newPhone);
    }
  };

  // const handleBooking = () => {
  //   if (stickyButtonVisible) {
  //     handleConfirm();
  //   }
  // };

  const fetchUserBookings = async () => {
    try {
      setIsLoading(true);

      const phone = localStorage.getItem("thefeels_phone");

      if (!phone) {
        setUserBookings([]);
        return;
      }

      // Нормализуем телефон перед отправкой
      let normalizedPhone = phone.replace(/\D/g, "");
      if (normalizedPhone.startsWith("8") && normalizedPhone.length === 11) {
        normalizedPhone = "7" + normalizedPhone.substring(1);
      }

      const response = await fetch(
        `${API_URL}/my-bookings?phone=${encodeURIComponent(normalizedPhone)}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // console.log("Bookings:", data);

      if (Array.isArray(data)) {
        setUserBookings(data);

        // if (data.length === 0) {
        //   showAlert("У вас пока нет броней");
        // }
      } else {
        showAlert("Ошибка получения броней");
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);

      showAlert("Ошибка загрузки данных");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelBooking = async (bookingId) => {
    setLoadingStates((prev) => ({ ...prev, [bookingId]: true }));
    try {
      const response = await fetch(`${API_URL}/delete-reservation`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: bookingId }),
      });

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      if (data.success) {
        showAlert("Бронирование успешно отменено");

        setUserBookings((prevBookings) =>
          prevBookings.filter((booking) => booking.id !== bookingId),
        );

        await fetchSchedule(selectedTable);
        // setSchedule(newSchedule);
      } else {
        showAlert(data.error || "Ошибка отмены бронирования");
      }
    } catch (error) {
      console.error("Error canceling booking:", error);
      showAlert("Ошибка отмены бронирования");
    } finally {
      setLoadingStates((prev) => ({ ...prev, [bookingId]: false }));
    }
  };

  useEffect(() => {
    if (showDialog) {
      document.documentElement.classList.add("modal-open");

      const originalBgColor = document.documentElement.style.getPropertyValue(
        "--tg-theme-bg-color",
      );
      const originalTextColor = document.documentElement.style.getPropertyValue(
        "--tg-theme-text-color",
      );

      document.documentElement.style.setProperty(
        "--tg-theme-bg-color",
        "transparent",
      );
      document.documentElement.style.setProperty(
        "--tg-theme-text-color",
        "#ffffff",
      );

      return () => {
        document.documentElement.classList.remove("modal-open");
        document.documentElement.style.setProperty(
          "--tg-theme-bg-color",
          originalBgColor,
        );
        document.documentElement.style.setProperty(
          "--tg-theme-text-color",
          originalTextColor,
        );
      };
    }
  }, [showDialog]);

  // const fetchUserData = async () => {
  //   return;
  // };

  const parseDateString = (dateString) => {
    const [day, month] = dateString.split(".");
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    // Если месяц слота (например, 1) меньше текущего (например, 12), значит это следующий год
    const year =
      parseInt(month, 10) < currentMonth ? currentYear + 1 : currentYear;

    return new Date(year, parseInt(month, 10) - 1, parseInt(day, 10));
  };

  const getDisplayDate = (dateString, timeString) => {
    const date = parseDateString(dateString);
    const [hours] = timeString.split(":").map(Number);

    // Для слотов с 00:00 до 06:00 (ночная смена) отображаем "завтрашнюю" дату,
    // так как фактически это продолжение предыдущего дня
    if (hours < 6) {
      date.setDate(date.getDate() + 1);
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${day}.${month}`;
  };

  return (
    <div className="telegram-app">
      <div className="app">
        <div className="photo-container">
          <img src={photo} alt="The FEEL'S" className="photo" />
        </div>
        <div className="tables-section">
          <h1 className="tables-header">
            Бильярдный клуб <br /> The Feel's
          </h1>
        </div>
        <div className="profile-button-container">
          <Link to="/how-to-find" className="profile-button">
            Как пройти к нам 🗺️
          </Link>
        </div>

        <div className="profile-button-container">
          <Link to="/contacts" className="profile-button">
            Контакты ☎️
          </Link>
        </div>

        <div className="profile-button-container">
          <Link to="/rules" className="profile-button">
            Правила клуба 📝
          </Link>
        </div>

        <div className="profile-button-container">
          <button
            className="profile-button"
            onClick={() => {
              setShowProfileModal(true);
              fetchUserBookings();
            }}
          >
            Посмотреть мои брони
          </button>
        </div>

        <div className="profile-button-container">
          <button
            className="profile-button cancel-button"
            onClick={() => {
              setShowProfileModal(true);
              fetchUserBookings();
            }}
          >
            Отменить бронь
          </button>
        </div>
        <div className="tables-section">
          <h2 className="tables-header-2">Выбери стол для брони, Дорогуша</h2>
        </div>
        <div className="tables-container">
          <button
            className={`table-button ${selectedTable === 1 ? "active leopard" : ""}`}
            onClick={() => handleTableSelect(1)}
          >
            Леопардовый
          </button>
          <button
            className={`table-button ${selectedTable === 2 ? "active blue" : ""}`}
            onClick={() => handleTableSelect(2)}
          >
            Синий
          </button>
          <button
            className={`table-button ${selectedTable === 3 ? "active green" : ""}`}
            onClick={() => handleTableSelect(3)}
          >
            Зелёный
          </button>
          <button
            className={`table-button ${selectedTable === 4 ? "active red" : ""}`}
            onClick={() => handleTableSelect(4)}
          >
            Красный
          </button>
        </div>

        <div className="price-banner">
          {/* <span className="price-text">{PRICE_PER_HOUR}₽/час</span> */}
          <div className="table-info">
            {selectedTable === 1 ? (
              <>
                <span>Американский (пул)</span>
                <span>Размер 8 футов</span>

                <div className="pricing-table">
                  <div className="pricing-row header">
                    <span className="time-period">Период</span>
                    <span className="price-value">Цена</span>
                  </div>

                  <div className="pricing-row standard">
                    <span className="time-period">
                      Будние дни (13:00-17:00)
                    </span>
                    <span className="price-value">
                      {pricing.weekday_day_price} ₽/час
                    </span>
                  </div>

                  <div className="pricing-row standard">
                    <span className="time-period">
                      Будние дни (17:00-01:00)
                    </span>
                    <span className="price-value">
                      {pricing.weekday_evening_price} ₽/час
                    </span>
                  </div>

                  <div className="pricing-row standard">
                    <span className="time-period">
                      Выходные и праздничные дни (все часы)
                    </span>
                    <span className="price-value">
                      {pricing.weekend_price} ₽/час
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <>
                <span>Американский (пул)</span>
                <span>Размер 9 футов</span>

                <div className="pricing-table">
                  <div className="pricing-row header">
                    <span className="time-period">Период</span>
                    <span className="price-value">Цена</span>
                  </div>

                  <div className="pricing-row standard">
                    <span className="time-period">
                      Будние дни (13:00-17:00)
                    </span>
                    <span className="price-value">
                      {pricing.weekday_day_price} ₽/час
                    </span>
                  </div>

                  <div className="pricing-row standard">
                    <span className="time-period">
                      Будние дни (17:00-01:00)
                    </span>
                    <span className="price-value">
                      {pricing.weekday_evening_price} ₽/час
                    </span>
                  </div>

                  <div className="pricing-row standard">
                    <span className="time-period">
                      Выходные и праздничные дни (все часы)
                    </span>
                    <span className="price-value">
                      {pricing.weekend_price} ₽/час
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="schedule-container">
          {schedule.map((day) => (
            <div key={day.date} className="date-block">
              <div className="date-header">{day.date}</div>
              <div>
                {/* 12:00-13:00 всегда занято */}
                {day.slots.map((slot, index) => {
                  const [hours] = slot.time.split(":").map(Number);
                  const showDate = hours < 6;

                  const isLunchBreakSlot = slot.time.trim() === "12:00-13:00";
                  const isAvailable = slot.available && !isLunchBreakSlot;

                  return (
                    // {/* 12:00-13:00 свободно */}
                    // {day.slots.map((slot, index) => {
                    //   const [hours] = slot.time.split(":").map(Number);
                    //   const showDate = hours < 6;

                    //   return (
                    <div
                      key={index}
                      // 12:00-13:00 всегда занято
                      className={`time-slot ${
                        isAvailable
                          ? selectedSlots.find(
                              (s) =>
                                s.time === slot.time && s.date === day.date,
                            )
                            ? "selected"
                            : "available"
                          : "unavailable"
                      }`}
                      onClick={() =>
                        isAvailable && handleSlotSelect(day.date, slot)
                      }
                      // 12:00-13:00 свободно
                      // className={`time-slot ${
                      //   slot.available
                      //     ? selectedSlots.find(
                      //         (s) =>
                      //           s.time === slot.time && s.date === day.date,
                      //       )
                      //       ? "selected"
                      //       : "available"
                      //     : "unavailable"
                      // }`}
                      // onClick={() =>
                      //   slot.available && handleSlotSelect(day.date, slot)
                      // }
                    >
                      <div className="slot-content">
                        {showDate && (
                          <div className="slot-date">
                            {getDisplayDate(day.date, slot.time)}{" "}
                            {/* Отображаем дату только для слотов с 00:00 до 06:00 */}
                          </div>
                        )}
                        {/* 12:00-13:00 всегда занято */}
                        <div className="slot-time">
                          {slot.time} {isAvailable ? "(Свободно)" : "(Занято)"}
                        </div>
                        {/* 12:00-13:00 свободно */}
                        {/* <div className="slot-time">
                          {slot.time}{" "}
                          {slot.available ? "(Свободно)" : "(Занято)"}
                        </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
          {scheduleError && (
            <p className="error-banner">
              Не удалось загрузить расписание...Попробуйте перезагрузить
              страницу.
            </p>
          )}
        </div>

        {stickyButtonVisible && !showWarning && !showDialog && (
          <button className="sticky-button" onClick={handleConfirm}>
            ЗАБРОНИРОВАТЬ
          </button>
        )}

        {showWarning && (
          <div className="warning-banner">
            <p>Пожалуйста, выберите соседние временные слоты.</p>
            <button className="reset-button" onClick={handleResetSlots}>
              Ок
            </button>
          </div>
        )}

        {showDialog && (
          <div className="modal">
            <div className="modal-content">
              <div>
                <h3>Подтверждение брони</h3>
                <p>Выбранное время:</p>
                <p className="selected-time-range">
                  {selectedSlots[0].date}, {formatTimeRange(selectedSlots)}
                </p>
                {/* <p className="total-price">
                  Стоимость: {calculateTotalPrice(selectedSlots)}₽
                </p> */}
                <div>
                  <input
                    type="text"
                    placeholder="Введите ваше имя"
                    value={userName}
                    onChange={handleNameChange}
                    maxLength={30}
                    className={`input-field ${userName.length === 30 ? "max-length" : ""}`}
                  />
                  <small className="input-hint">
                    {userName.length}/30 символов (только буквы и пробел)
                  </small>
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Введите ваш телефон"
                    value={userPhone}
                    onChange={handlePhoneChange}
                    className="input-field"
                  />
                  <small className="input-hint">Только цифры</small>
                </div>
                <div className="agreement">
                  <label className="agreement-label">
                    <input
                      type="checkbox"
                      checked={isAgreed}
                      onChange={(e) => setIsAgreed(e.target.checked)}
                      className="agreement-input"
                    />

                    <span className="custom-checkbox" />

                    <span className="agreement-text">
                      Я даю согласие на обработку своих персональных данных в
                      соответствии с{" "}
                      <Link
                        target="_blank"
                        style={{ fontStyle: "italic", color: "#cfcfcf" }}
                        to={"/policy"}
                      >
                        Политикой обработки персональных данных
                      </Link>{" "}
                      и ознакомлен с{" "}
                      <Link
                        style={{ fontStyle: "italic", color: "#cfcfcf" }}
                        target="_blank"
                        to={"/agreement"}
                      >
                        Согласием на обработку персональных данных
                      </Link>
                    </span>
                  </label>
                </div>
                <div className="dialog-buttons">
                  <button
                    className="confirm-button"
                    onClick={handleDialogConfirm}
                    disabled={
                      !userName || !userPhone || !isAgreed || isLoadingBooking
                    }
                  >
                    Подтвердить
                  </button>
                  <button className="close-modal" onClick={handleDialogCancel}>
                    Отмена
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showProfileModal && (
          <div className="profile-modal">
            <div className="profile-modal-content">
              <div className="profile-modal-header">
                <h3>
                  Мои брони{" "}
                  {userName &&
                    userPhone !== "+7" &&
                    `(${userName}, ${userPhone})`}
                </h3>
                <button
                  className="close-profile-modal"
                  onClick={() => setShowProfileModal(false)}
                >
                  ✕
                </button>
              </div>

              <div className="bookings-container">
                {isLoading ? (
                  <div className="loading">Загрузка...</div>
                ) : userBookings.length > 0 ? (
                  userBookings.map((booking) => (
                    <div key={booking.id} className="booking-item">
                      <div className="booking-date">{booking.date}</div>
                      <div className="booking-details">
                        <div className="booking-table">
                          Стол: {booking.table_name}
                        </div>
                        <div className="booking-time">
                          {booking.start_time} - {booking.end_time}
                        </div>
                        <button
                          className="cancel-booking-button"
                          onClick={() => handleCancelBooking(booking.id)}
                        >
                          Отменить
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-bookings">У вас пока нет броней</div>
                )}
              </div>
            </div>
          </div>
        )}

        <footer className="footer">
          <div className="footer-content">
            <div className="footer-section">
              <h3>The FEEL'S</h3>
              <p>Бильярдный клуб</p>
              <p>© 2024-2026 Все права защищены</p>
              <Link to="/policy" target="_blank">
                Политика конфиденциальности
              </Link>
            </div>
            <div className="footer-section">
              <h3>Контакты</h3>
              <p>
                Телефон: <a href="tel:+79119901993">+7 (911) 990-1993</a>
              </p>
              <p>Адрес: Санкт-Петербург, пер. Гривцова 1/64В</p>
            </div>
            <div className="footer-section">
              <h3>Режим работы</h3>
              <p>Пн-чт: 13:00 - 01:00</p>
              <p>Пт-вс: 13:00 - 03:00</p>
            </div>
            <div className="footer-section">
              <p>
                Индивидуальный предприниматель Тращевский Филипп
                Владимирович
              </p>
              <p>ИНН: 784804090474</p>
              <p>ОГРНИП: 321784700079246</p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default HomePage;

